import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-93b4ea1c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout-body"
};
const _hoisted_2 = {
  class: "table-page-search-wrapper1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_space = _resolveComponent("a-space");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_card = _resolveComponent("a-card");
  const _component_a_table = _resolveComponent("a-table");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_DMPrice = _resolveComponent("DMPrice");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_spin, {
    spinning: $setup.DMConfig.loading
  }, {
    default: _withCtx(() => [_createVNode(_component_a_card, {
      style: {
        "margin-bottom": "8px"
      },
      id: "advanced_search"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form, {
        layout: "inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, {
          gutter: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, null, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: '客户'
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                "allow-clear": "",
                value: $setup.DMConfig.QueryParam.SearchValue,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.QueryParam.SearchValue = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, null, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: '产品'
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                "allow-clear": "",
                value: $setup.DMConfig.QueryParam.SearchValue1,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.QueryParam.SearchValue1 = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, null, {
            default: _withCtx(() => [_createVNode(_component_a_space, {
              size: 5
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.OnQuery,
                loading: $setup.DMConfig.loading
              }, {
                default: _withCtx(() => [_createTextVNode("搜索")]),
                _: 1
              }, 8, ["onClick", "loading"]), _createVNode(_component_a_button, {
                onClick: _cache[2] || (_cache[2] = () => $setup.DMConfig.QueryParam = {})
              }, {
                default: _withCtx(() => [_createTextVNode("重置")]),
                _: 1
              }), _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.OnCreate
              }, {
                default: _withCtx(() => [_createTextVNode("新增")]),
                _: 1
              }, 8, ["onClick"]), _createVNode(_component_a_button, {
                type: "primary",
                danger: "",
                onClick: _cache[3] || (_cache[3] = () => $setup.OnExport())
              }, {
                default: _withCtx(() => [_createTextVNode("导出")]),
                _: 1
              }), _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.OnDelete,
                danger: "",
                disabled: $setup.DMConfig.selectedRowKeys.length == 0
              }, {
                default: _withCtx(() => [_createTextVNode("删除")]),
                _: 1
              }, 8, ["onClick", "disabled"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_a_card, {
      bordered: false,
      bodyStyle: {
        padding: '10px 10px 10px 10px'
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_a_table, {
        tableLayout: 'fixed',
        dataSource: $setup.DMConfig.DataSource,
        columns: $setup.DMConfig.Columns,
        bordered: "",
        size: "small",
        rowKey: $setup.DMConfig.RowKey,
        pagination: $setup.DMConfig.QueryWhere,
        onChange: $setup.OnTableChange,
        scroll: {
          y: _ctx.tableHeight,
          scrollToFirstRowOnChange: true
        },
        rowClassName: (record, index) => index % 2 === 1 ? 'table-striped' : null,
        "row-selection": {
          selectedRowKeys: $setup.DMConfig.selectedRowKeys,
          onChange: $setup.onSelectChange,
          fixed: true
        }
      }, null, 8, ["dataSource", "columns", "rowKey", "pagination", "onChange", "scroll", "rowClassName", "row-selection"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["spinning"])]), _createVNode(_component_DMPrice, {
    ref: "DMPriceref",
    onOk: $setup.LoadData
  }, null, 8, ["onOk"])], 64);
}